import React, { memo } from 'react'
import ContentLoader from 'react-content-loader'

const TripListSkeleton = props => {


    return (
        <div className={`col-box ${props.type}-col-layout`} key={`skeleton-${props.type}`}>
            <div className="container">
                <div className="col-wrapper">
                    {(() => {
                        if(props.type==="one" || !props.type)
                        return ["1", "2",].map(element => {

                            return <div className="cards" key={`skeleton-${props.type}-${element}`}>
                                <ContentLoader className="trip-list-skeleton cards-wrapper"
                                    height={450}
                                    width={400}
                                    speed={2}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    {...props}
                                >
                                    <rect x="0.1%" y="0%" rx="100" ry="0" width="25%" height="100%" /> {/*Image */}

                                    <rect x="30.5%" y="5.7%" rx="0" ry="0" width="200" height="12" /> {/*Destination */}

                                    <rect x="75%" y="7.3%" rx="0" ry="0" width="150" height="12" /> {/*Price */}

                                    <rect x="30.5%" y="12%" rx="0" ry="0" width="400" height="18" /> {/*Heading */}

                                    <rect x="30.5%" y="25%" rx="0" ry="0" width="100" height="16" /> {/*Tag1 */}
                                    <rect x="43%" y="25%" rx="0" ry="0" width="100" height="16" /> {/*Tag2 */}
                                    <rect x="56%" y="25%" rx="0" ry="0" width="100" height="16" /> {/*Tag3 */}

                                    <rect x="30.5%" y="40%" rx="0" ry="0" width="750" height="8" /> {/*Description1 */}
                                    <rect x="30.5%" y="43.9%" rx="0" ry="0" width="730" height="8" /> {/*Description12 */}

                                    <rect x="30.5%" y="250" rx="0" ry="0" width="300" height="8" /> {/*fact1 */}
                                    <rect x="30.5%" y="265" rx="0" ry="0" width="300" height="8" /> {/*fact2 */}
                                    <rect x="30.5%" y="280" rx="0" ry="0" width="300" height="8" /> {/*fact3 */}

                                    <rect x="30.5%" y="330" rx="0" ry="0" width="150" height="8" /> {/*variation */}
                                    <rect x="30.5%" y="360" rx="0" ry="0" width="150" height="20" /> {/*variationdata */}

                                    <rect x="55%" y="330" rx="0" ry="0" width="150" height="8" /> {/*departure */}
                                    <rect x="55%" y="360" rx="0" ry="0" width="150" height="20" /> {/*departureData */}

                                    <rect x="79%" y="380" rx="0" ry="0" width="150" height="40" /> {/*book button */}


                                </ContentLoader>

                            </div>

                        })
                        else if(props.type==="two")
                        return ["1", "2",].map(element => {

                            return <div className="cards" key={`skeleton-two-${element}`}>
                                <ContentLoader className="trip-list-skeleton cards-wrapper"
                                    height={650}
                                    width={540}
                                    speed={2}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    {...props}
                                >
                                    <rect x="0.5" y="0" rx="100" ry="0" width="100%" height="40%" /> {/*Image */}

                                    <rect x="5%" y="45%" rx="0" ry="0" width="200" height="12" /> {/*Destination */}
                                    <rect x="70%" y="47%" rx="0" ry="0" width="20%" height="12" /> {/*Price */}
                                    <rect x="5%" y="50%" rx="0" ry="0" width="250" height="16" /> {/*Title */}

                                    <rect x="5%" y="57%" rx="0" ry="0" width="78%" height="8" /> {/*Short Desc */}
                                    <rect x="5%" y="59%" rx="0" ry="0" width="73%" height="8" /> {/*Short Desc */}

                                    <rect x="5%" y="65%" rx="0" ry="0" width="65%" height="13" /> {/*Fact1 */}
                                    <rect x="5%" y="70%" rx="0" ry="0" width="65%" height="13" /> {/*Fact2 */}
                                    <rect x="5%" y="75%" rx="0" ry="0" width="65%" height="13" /> {/*Fact3 */}

                                    <rect x="5%" y="85%" rx="0" ry="0" width="35%" height="13" />{/*variation */}
                                    <rect x="50%" y="85%" rx="0" ry="0" width="35%" height="13" />{/*departure */}

                                    <rect x="65%" y="93%" rx="0" ry="0" width="25%" height="25" />{/*Button */}
                                </ContentLoader>

                            </div>

                        })
                    })()}

                </div>
            </div>
        </div>
    )
}

export default memo(TripListSkeleton)